"use client";
import type { HeroBlock } from "@/payload-types";
import { useHeaderTheme } from "@onclicks/sharedcomponents/HeaderTheme";
import { Media } from "@onclicks/sharedcomponents/Media/Media";
import RichText from "../RichText";
import { cn } from "@/utilities/ui";
import React, { useEffect } from "react";
import { CMSLink } from "../../components/CMSLink";

export const HighImpactHero: React.FC<HeroBlock> = ({
  title,
  subtitle,
  anchor,
  links,
  media,
  showContent,
  richText,
  variant,
  variant_title,
}) => {
  const { setHeaderTheme } = useHeaderTheme();

  useEffect(() => {
    setHeaderTheme("dark");
  });

  const textAlignementClasses = {
    default: "text-left",
    center: "text-center",
    media_left: "",
  };

  const textPlaceClasses = {
    default: "mb-5",
    high_title: "mb-32 md:mb-20",
    media_left: "",
  };

  const containerAlignementClasses = {
    default: "justify-start",
    center: "justify-center",
    media_left: "",
  };

  return (
    <div
      id={
        (anchor?.value &&
          typeof anchor.value === "object" &&
          anchor?.value.anchor) ||
        ""
      }
      className={cn(
        "relative flex h-[100vh] lg:h-[calc(100vh-3.5rem)] items-end text-white",
        containerAlignementClasses[variant || "default"],
      )}
    >
      <div
        className={`px-4 md:px-14 lg:px-32 mb-8 z-10 relative flex items-center justify-center`}
      >
        <div className={textPlaceClasses[variant_title || "default"]}>
          {title && (
            <h1
              className={cn(
                "text-white mb-3",
                textAlignementClasses[variant || "default"],
              )}
            >
              {title}
            </h1>
          )}

          {subtitle && (
            <h2
              className={cn(
                "text-white mb-3",
                textAlignementClasses[variant || "default"],
              )}
            >
              {subtitle}
            </h2>
          )}

          {richText && (
            <RichText
              className={cn(`text-white text-sm md:text-base lg:text-lg`)}
              data={richText}
              enableGutter={false}
            />
          )}

          {Array.isArray(links) && links.length > 0 && (
            <ul
              className={cn(
                `flex flex-col md:flex-row w-full md:w-auto gap-4`,
                containerAlignementClasses[variant || "default"],
              )}
            >
              {links.map(({ link }, i) => {
                return (
                  <li key={i}>
                    <CMSLink
                      {...link}
                      className={`text-xl px-8 py-6 font-thin w-full md:w-auto`}
                    />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      <div className="min-h-[80vh] select-none">
        <div className="absolute inset-0 bg-linear-to-t from-black/60 to-black/10" />
        {media && typeof media === "object" && (
          <Media
            fill
            imgClassName="-z-10 object-cover bg-bottom"
            priority
            resource={media}
          />
        )}
      </div>
    </div>
  );
};
